import Join from "../../Assets/img/Join.png";

const JoinChorusOne = () => {
  return (
    <section className="px-6 pb-20 text-gray-900 bg-white md:px-16 lg:px-28">
      <div className="flex flex-col items-center justify-between gap-16 mx-auto max-w-7xl md:flex-row">
        {/* Left Text Section */}
        <div className="space-y-8 md:w-1/2">
          <div>
            <h2 className="relative inline-block text-4xl font-semibold text-black md:text-6xl">
              Join Chorus One
              {/* underline brush stroke */}
              <span className="absolute left-0 bottom-0 w-48 h-[6px] bg-[#00a0a0] rounded-full transform translate-y-3 opacity-90"></span>
            </h2>
          </div>

          <p className="text-lg leading-relaxed text-gray-700">
            We are a global group of ambitious people who believe in the
            transformational power of blockchain technology. Come work with us
            and make your next career move the best one yet.
          </p>

          <div className="flex items-center">
            <p
              href="#"
              className="flex items-center justify-center py-1 pl-2 pr-4 font-medium text-white transition bg-black rounded-full hover:bg-teal-800"
            >
              <span className="px-3 py-2 mr-2 text-xl text-black bg-white border border-black rounded-full">
                →
              </span>
              See Open Positions
            </p>
          </div>
        </div>

        {/* Right Image Grid */}
        <div className="relative grid grid-cols-2 gap-4 md:w-1/2">
          {/* Top Right */}
          <div className="relative flex justify-end col-span-2">
            <img
              src={Join}
              alt="Platform Engineers"
              className="rounded-2xl w-[90%] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinChorusOne;
